/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * This is the legacy eventbus.js to communicate with cotd-website
 */
export var legacyEventBus = true ? window.eventBus : undefined;